import { createContext, useContext } from 'react';

type DialogCloseContextType = () => void;

export const DialogCloseContext = createContext<DialogCloseContextType | null>(
  null
);

export const useDialogClose = () => {
  return useContext(DialogCloseContext);
};
